export const HEADER_BAR_PAGE_TITLE = '__header-bar-page-title';
export const HEADER_BAR_BACK_ACTION = '__header-back-action';
export const HEADER_BAR_RIGHT_CONTENT = '__header-bar-right-content';
